import React from 'react';
import { Provider as StoreProvider } from 'react-redux';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Route, Routes } from 'react-router';
import * as Sentry from '@sentry/react';

import { Admin, Root } from './pages';

import Router from './Router';

import DayProvider from './contexts/day';
import SubscriptionProvider from './contexts/subscription';
import ThemeProvider from './contexts/theme';

import { history } from './utils/navigation';
import { store } from './store';

import { ROUTES } from './constants/routes';

import './styles/fonts.css';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.VELA_ENVIRONMENT,
});

export default function Application() {
  return (
    <StoreProvider store={store}>
      <DndProvider backend={HTML5Backend}>
        <SubscriptionProvider>
          <Router history={history}>
            <ThemeProvider>
              <DayProvider>
                <Routes>
                  <Route path={`${ROUTES.ADMIN.ROOT}${ROUTES.WILDCARD}`} Component={Admin} />
                  <Route path={ROUTES.WILDCARD} Component={Root} />
                </Routes>
              </DayProvider>
            </ThemeProvider>
          </Router>
        </SubscriptionProvider>
      </DndProvider>
    </StoreProvider>
  );
}
